import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
	Loader,
	BaasicTable,
	TableFilter,
	BaasicConfirmModal,
	BaasicHeader,
	BaasicButton,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';

const InventoryListTemplate = props => {
	const {
		t,
		viewStore,
		viewStore: {
			listStore,
			tableData,
			queryUtility,
			loading,
			data,
			exportDataToCSV,
			columnFilterSetup,
			removeFiltersModal
		},
		actions,
		headerCell,
	} = props;
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.INVENTORY.PAGETITLE">
				<BaasicButton
					className="btn btn--med btn--primary btn--primary--negative"
					icon="fa fa-file-export spc--right--sml"
					disabled={data.length === 0}
					onClick={exportDataToCSV}
					label="EXPORTTOXLS.TITLE"
				/>
			</BaasicHeader>
			<div className="inventory-table">
				<BaasicTable
					{...{
						listStore,
						tableData,
						queryUtility,
						actions,
						headerCell,
						data: data.slice(),
						viewStore,
					}}
				/>
				<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
				<BaasicConfirmModal modalParams={removeFiltersModal.removeFiltersConfirm} />
				<ReactTooltip />
			</div>
		</section>
	);
};

export default defaultTemplate(InventoryListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product-inventory/pages/InventoryListTemplate.jsx